import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import View from './AdvWorkflowView';
import { extendTree } from './AdvWorkflowActions';
import { currentClientId } from './AdvWorkflowSelector';
import { isNonEmptyString, createCustomPropType } from '../../../js/app/react/validators';

const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientId(state, ownProps),
});
const mapDispatchToProps = dispatch => ({
  extendTree: (branch, workflowId, clientId) => {
    dispatch(extendTree(branch, workflowId, clientId));
  },
});

const AdvWorkflowContainer = connect(mapStateToProps, mapDispatchToProps)(View);

AdvWorkflowContainer.propTypes = {
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  branch: PropTypes.arrayOf(PropTypes.number.isRequired),
};

export default AdvWorkflowContainer;
